import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { contextData } from '../../context/ContextProvider';
import { Url } from '../../constants/ApiUrlConstants';
import sideCorner from '../../assets/Images/sideCorner (1).png';
import './Proxy.css';
import { GET, POST } from '../Common/HttpMethods/HttpMethods';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header/Header';
import { decryptToken, SecretKey, set } from '../Encryption/EncryptDecrypt';
import FailModal from '../Common/Popups/FailModal';
import { Cuurent_UserIdProxy } from '../CommonCase/CommonFunctions';


export const handleLogin = async (
  encryptedData,
  isAdmin = false,
  {
    setLoading,
    POST,
    Url,
    token,
    decryptToken,
    setIsProxy,
    navigate,
    setActive,
    TokenParseAPI,
    handleFailure,
    setLoggedIn
  }
) => {
  try {
    if (encryptedData) {
      setLoading(true);
      const proxyLogin = await POST(Url.ProxyLogin, token, encryptedData);

      if (proxyLogin?.SUCCESS) {
        const proxyStatus = decryptToken(proxyLogin?.isProxy);
        setIsProxy(proxyStatus);
        sessionStorage.setItem("TOKEN", proxyLogin?.TOKEN);
        navigate('/main');
        setActive("tab1");
        TokenParseAPI(proxyLogin?.TOKEN, POST, Url, sessionStorage, navigate, setLoggedIn, setActive, setLoading);
      } else {
        handleFailure(proxyLogin.STATUS, isAdmin ? "Failed Admin Login." : "Failed Proxy Login.");
      }
      setLoading(false);
    }
  } catch (error) {
    handleFailure(null, isAdmin ? "Failed Admin Login." : "Failed Proxy Login.");
  }
};

export const handleUserChange = (e,setIsDiabled,setProxyUser) => {
  if (!e) {
    setIsDiabled(true);
  } else {
    setProxyUser({ fullName: e.label, staffId: e.value?.staffId, userId: e.value?.userId });
    setIsDiabled(false);
  }
};

export const handleCloseFailModal = (setOpenFailModal) => {setOpenFailModal(false)};
export const handleSessionExpClose = (navigate) => {
  sessionStorage.clear();
  navigate('/login');
};

// Refactor TokenParseAPI to accept dependencies as parameters
export const TokenParseAPI = async (
  token,
  POST,
  Url,
  sessionStorage,
  navigate,
  setLoggedIn,
  setActive,
  setLoading
) => {
  try {
    const body = { token };
    const userData = await POST(Url.getUserData, token, body);

    if (userData.SUCCESS) {
      sessionStorage.setItem("UserIdProxy1", userData?.userId);
      sessionStorage.setItem("EMAIL1", userData?.emailId);
      sessionStorage.setItem("USERNAME1", userData?.fullName);
      sessionStorage.setItem("StaffId1", userData?.staffId);
      sessionStorage.setItem("RBAC_roles1", userData?.rbac);
      sessionStorage.setItem("USER_ROLES1", userData?.role);
      sessionStorage.setItem("gender1", userData?.gender);
      setLoggedIn(true);
      navigate('/main');
      setActive("tab1");
      setLoading(false);
    }else{
      console.error("Error fetching user data:");
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};


const Proxy = () => {
  let navigate = useNavigate();
  const [getAllEmployeeOptions, setAllEmployeeOptions] = useState([]);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDiabled, setIsDiabled] = useState(true);
  const [proxyUser, setProxyUser] = useState();
  const { setLoading, setActive, setIsProxy, setLoggedIn } = useContext(contextData);
  const token = sessionStorage.getItem("TOKEN");

  const getEmployeeData = async () => {
    try {
      setLoading(true);
      const getAllEmployee = await GET(Url.getEmployees, token);

      if (getAllEmployee.SUCCESS) {
        setAllEmployeeOptions(getAllEmployee.DATA.map(employee => ({
          value: employee,
          label: employee.fullName,
        })));
      } else {
        handleFailure(getAllEmployee.STATUS, "Failed to fetch Audit Table data.");
      }
      setLoading(false);
    } catch (error) {
      handleFailure(null, "Failed to fetch Audit table data.");
    }
  };


  const handleFailure = (status, message) => {
    setFailMessage(message);
    if (status === 401) {
      setSessionExpiredModal(true);
    } else {
      setOpenFailModal(true);
    }
    setLoading(false);
  };



  useEffect(() => {
    getEmployeeData();
  }, []);

  const handleAdminReturn = () => {
    const userId = Cuurent_UserIdProxy();
    const encryptedData = { userId: set(SecretKey, userId) };
    handleLogin(encryptedData, true, {
      setLoading,
      POST,
      Url,
      token,
      decryptToken,
      setIsProxy,
      navigate,
      setActive,
      TokenParseAPI,
      handleFailure,
      setLoggedIn
    });
  };

  const handleProxyUserLogin = () => {
    const encryptedData = { userId: set(SecretKey, proxyUser?.userId) };
    handleLogin(encryptedData, false, {
      setLoading,
      POST,
      Url,
      token,
      decryptToken,
      setIsProxy,
      navigate,
      setActive,
      TokenParseAPI,
      handleFailure,
      setLoggedIn
    });
  };

 
  return (
    <div onClick={() => showDropdown && setShowDropdown(false)}>
      <header className='header'>
        <Header setShowDropdown={setShowDropdown} showDropdown={showDropdown} />
      </header>
      <div className='proxy-container'>
        <div className="proxy-user-select">
          <p className='proxy-title'>Select Associate Name (Select Associate ID)</p>
          <div className="select-proxy-user">
            <Select
              options={getAllEmployeeOptions}
              placeholder="Select Proxy User"
              onChange={handleUserChange}
              isSearchable={true}
              maxMenuHeight={190}
              autoFocus={true}
            />
          </div>
          <div className='proxy-btns'>
            <button className='proxy-btn' onClick={handleAdminReturn}>Go Back To Admin Dashboard</button>
            <button className='proxy-btn' onClick={handleProxyUserLogin} disabled={isDiabled}>Proxy Login</button>
          </div>
        </div>
      </div>
      <div className="side-corner-img">
        <img src={sideCorner} alt="side corner" />
      </div>

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={handleSessionExpClose}
        recallFunctiononClose={handleSessionExpClose}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={handleCloseFailModal}
        recallFunctiononClose={handleCloseFailModal}
      />
    </div>
  );
};

export default Proxy;
